export default __webpack_public_path__ + "static/media/email-prospect-abf.f439167d.png";